module.exports = __webpack_public_path__ + "static/media/icon_money-01.ee16ee56.svg";